import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-prim-hero',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './prim-hero.component.html',
  styleUrl: './prim-hero.component.css',
})
export class PrimHeroComponent {
  @Input() firstName: string = '';
}
